<script>
    import Transition from "../components/Transition.svelte";
    import {
        error as resourcesFetchingError,
        load as loadResources,
        resources,
    } from "../stores/resourceStore";
    import {
        error as railcarsFetchingError,
    } from "../stores/railcarStore";
    import {railcarsUrl} from "../urls";
    import {customFetch} from "../customFetch";
    import {notifications} from "../notifications";
    import {onMount} from "svelte";
    import {
        binaryView,
        dateView,
        dropdownView,
        imageView,
        labelView,
        valueView,
        saveRows
    } from "../tableUtils";
    import StraightTable from "../components/StraightTable.svelte";

    $: $resourcesFetchingError && notifications.danger($resourcesFetchingError)
    $: $railcarsFetchingError && notifications.danger($railcarsFetchingError)

    onMount(init);

    function init() {
        loadResources();
        load();
    }

    let resourcesMap;
    $: {
        resourcesMap = $resources.reduce(function (map, obj) {
            map[obj.Name] = obj.ID;
            return map;
        }, {});

        columns = [
            {title: 'ID', field: 'ID', sortable: true, defaultValue: null, editView: labelView},
            {title: 'Model', field: 'NewModel', sortable: false, defaultValue: null, editView: binaryView("fbx", "ModelData")},
            {title: '', field: 'ResourceId', sortable: false, defaultValue: 0, editView: imageView},
            {title: 'Resource Type', field: 'ResourceId', sortable: true, defaultValue: 0, editView: dropdownView(resourcesMap)},
            {title: 'Length', field: 'Length', sortable: true, defaultValue: 0, editView: valueView("number", 0.01, 0, 10)},
            {title: 'Updated At', field: 'UpdatedAt', sortable: true, defaultValue: new Date(), editView: dateView},
        ];
    }

    let rows = [];
    let columns = [];

    async function load() {
        try {
            let response = await customFetch(railcarsUrl());
            let data = await response.json();
            for (let i = 0; i < data.length; i++) {
                data[i].UpdatedAt = new Date(data[i].UpdatedAt)
            }
            rows = data;
        } catch (e) {
            notifications.danger(
                `Error loading railcars: ${e.message}`
            );
        }
    }

    async function save(e) {
        const rows = e.detail.data;
        let fields = columns.map(elem => elem.field);
        await saveRows(rows, fields, railcarsUrl());
        await load();
    }
</script>

<Transition>
    <StraightTable data={rows} {columns} on:change={save}/>
</Transition>
